import React, { useEffect, useState } from "react";
import alertify from "alertifyjs";
import useFetchData from "../../hooks/useFetchData";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { useTranslation } from "react-i18next";
import { Label } from "@progress/kendo-react-labels";

// bütün verinin çekildiği, filtrelemenin ön yüzde yapıldığı multiselectlerde kullanılabilir.

const CommonMultiSelect = ({
  id,
  name,
  label,
  dataItemKey,
  textField,
  onChange,
  fetchUrl,
  required,
  disabled,
  opened,
  value,
}) => {
  const { data, loading, error } = useFetchData(fetchUrl);
  const { t } = useTranslation();
  useEffect(() => {
    if (error) {
      alertify.error(error);
    }
  }, [error]);
  return (
    <>
      {label && (
        <Label
          editorId={id}
          style={{ fontSize: 10, marginBottom: 0 }}
          editorValid={(required && value?.length > 0) || !required}
        >
          {label}
        </Label>
      )}
      <MultiSelect
        name={name}
        id={id}
        style={{ width: "100%" }}
        data={data?.data || []}
        dataItemKey={dataItemKey}
        textField={textField}
        onChange={onChange}
        loading={loading}
        required={required}
        disabled={disabled}
        placeholder={t("choose")}
        opened={opened}
        value={value}
      />
    </>
  );
};

export default CommonMultiSelect;
